module.exports = __webpack_public_path__ + "img/CT BRU Profile.dd1c0633.webp";